<template>
  <!-- Takt Day -->
  <div>
  <!-- <v-subheader
    style="height: 30px"
    >
    Select Taktime Starts Regular Week
  </v-subheader> -->
  <v-layout
    justify-space-between
    >
    <div
      v-for="option in options"
      :key="option.name + option.color"
      >
    <div class="date"
    v-if="option.date"
      >
      {{option.date.substring(8, 10)}}
    </div>
    <v-btn
      rounded
      :style="`color: ${option.textcolor}; min-width: 0px; width: 36px; margin: 0px; ${option.free_day?'border: solid #EF5350 2px !important':''}`"
      :color="option.color"
      :small="option.small"
      @click="$emit('input', option)"
      >
      {{option.name}}
    </v-btn>
  </div>
    <!-- @click="selectTaktStart(index, activeProject.calendarSettings.selectedTaktStartWeekDays, activeProject.calendarSettings.blockedTaktStartWeekDays)"
    :color="getButtonColor(index, activeProject.calendarSettings.selectedTaktStartWeekDays, activeProject.calendarSettings.blockedTaktStartWeekDays)" -->
  </v-layout>
</div>
</template>
<script>
  export default {
    props: ['options', 'sessionData', 'activeProject'],
  }
</script>
<style scoped>
  .bordered {
    border: solid #EF5350 2px !important;
  }
  .date {
    text-align: center;
  }
</style>
